import styled from 'styled-components';

import Button from 'components/modules/button/Button';
import Modal from 'components/modules/modal/Modal';

interface ModalMemoProps {
  item: any;
  onClose: (item: any) => void;
}

const ModalInitialize = ({ item, onClose }: ModalMemoProps) => {
  const _Close = () => {
    onClose(undefined);
  };

  const _ConfirmInitialize = () => {
    onClose(item);
  };

  return (
    <Modal isOpen={true} onClose={_Close}>
      <ModalTemplate>
        <HeaderWrap>
          <HeaderTitle>{'비밀번호 초기화'}</HeaderTitle>
        </HeaderWrap>
        <ContentsWrap>
          <SubTitleWrap>비밀번호를 초기화 하시겠습니까?</SubTitleWrap>
        </ContentsWrap>
        <FooterWrap>
          <Button title="아니오" color="secondary" onClick={_Close} />
          <Button title="네" color="primary" onClick={_ConfirmInitialize} />
        </FooterWrap>
      </ModalTemplate>
    </Modal>
  );
};

const ModalTemplate = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100%);
  max-width: 450px;
  flex-flow: column nowrap;
  background-color: #abc9df;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
`;
const HeaderWrap = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  background-color: #11497e;
  border-radius: 10px 10px 0 0;
`;
const HeaderTitle = styled.div`
  display: flex;
  width: 100%;
  height: 50px;
  align-items: center;
  margin-left: 20px;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
`;
const ContentsWrap = styled.div`
  padding: 20px;
  display: flex;
  flex-flow: column nowrap;
  @media (max-width: 319px) {
    padding: 0 10px;
  }
`;
const SubTitleWrap = styled.div`
  width: 100%;
  padding: 20px 10px;
  display: flex;
  justify-content: center;
  font-size: 1.1rem;
  color: #333;
`;
const FooterWrap = styled.div`
  padding: 20px;
  flex: 0 0 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;

  button {
    margin: 0 5px;
    border-radius: 10px;
    min-height: 40px;
    max-width: 140px;
    cursor: pointer;
  }
`;

export default ModalInitialize;
